import {
  type GetPlacesOfSafetyV1Response,
  type GetPlacesOfSafetyV1ResponseUnbranded,
  GetPlacesOfSafetyV1ResponseSchema,
  parseAxiosResponse,
} from "@thalamos/common";
import { type AxiosInstance } from "axios";

export type GetPlacesOfSafetyResponseUnbranded =
  GetPlacesOfSafetyV1ResponseUnbranded;
export const GetPlacesOfSafetyResponseSchema =
  GetPlacesOfSafetyV1ResponseSchema;
export type GetPlacesOfSafetyResponse = GetPlacesOfSafetyV1Response;

const parseResponseGetPlaceOfSafetyV1 = parseAxiosResponse(
  GetPlacesOfSafetyV1ResponseSchema,
);

///

export const config = {
  placeOfSafety: {
    getAll: () => ({
      url: `/api/place-of-safety/`,
      method: "get",
      transformResponse: parseResponseGetPlaceOfSafetyV1,
    }),
  },
};

export const placeOfSafetyRequests = (apiAxios: AxiosInstance) => {
  return {
    placeOfSafety: {
      getAll: () =>
        apiAxios.request<GetPlacesOfSafetyResponse>(
          config.placeOfSafety.getAll(),
        ),
    },
  };
};
